// extracted by mini-css-extract-plugin
module.exports = {"profilePhoto":"style_profilePhoto__3bX2e","photo":"style_photo__3pw2A","uploadMenu":"style_uploadMenu__1cemo"};